import {
  createContext,
  useContext,
  useEffect,
  type Dispatch,
  type ReactNode,
  type SetStateAction,
} from 'react';

/**
 * Terceiro segmento do breadcrumb, além de "Home > item do menu" — pra telas
 * cujo nome de exibição não é fixo: a aba ativa de um hub, o registro aberto
 * numa tela de detalhe. Cópia estrutural do protótipo (`useBreadcrumbLabel`,
 * `BreadcrumbContext`), com nome em português, no padrão de provedor +
 * gancho.
 *
 * `CascaDeArea.tsx` é o único provedor (guarda o estado, repassa pra
 * `Migalhas.tsx`); qualquer tela dentro dela pode chamar `useMigalhaExtra`
 * pra preencher o terceiro segmento, e ele some sozinho quando a tela
 * desmonta — sem isso, o rótulo de uma tela vazaria pra próxima que não o
 * define.
 */
const MigalhaExtraContext = createContext<Dispatch<SetStateAction<string | null>> | null>(null);

export function ProvedorDeMigalhaExtra({
  definir,
  children,
}: {
  definir: Dispatch<SetStateAction<string | null>>;
  children: ReactNode;
}) {
  return <MigalhaExtraContext.Provider value={definir}>{children}</MigalhaExtraContext.Provider>;
}

/** Define o terceiro segmento do breadcrumb enquanto a tela chamadora está montada. `undefined`/`null` limpa. */
export function useMigalhaExtra(rotulo: string | null | undefined): void {
  const definir = useContext(MigalhaExtraContext);

  useEffect(() => {
    definir?.(rotulo ?? null);
    return () => definir?.(null);
  }, [rotulo, definir]);
}
